
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parcerias",
      function () {
        return require("private-next-pages/parcerias/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parcerias"])
      });
    }
  